/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {temporaryMcpCreateChart} from '../api'

export const useMutationTemporaryMcpCreateChart = createReactQueryMutationHook('temporaryMcpCreateChart', temporaryMcpCreateChart)
